export var EEORoutes = {
    "/eeo/form/{formId:[0-9]*}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.eeo-questions",
        "params": {
            formId: "",
        },
        "type": "frontend",
        "component": "eeoQuestions",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: [ "interview_bank", "eeo_questions"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./eeo.module.js");
                },
            },
        ],
    },

    "/eeo/:brand_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.eeo",
        "type": "frontend",
        "component": "eeoController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["eeo"]
        },
        onEnter: ['$state', 'hUser', function ($state, hUser) {
            if (hUser.isTopLevelContext()) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./eeo.module.js");
                },
            },
        ],
    }
};